import { render, staticRenderFns } from "./monitoracao-detalhe.vue?vue&type=template&id=5b3cd98f"
import script from "./monitoracao-detalhe.vue?vue&type=script&lang=js"
export * from "./monitoracao-detalhe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports